module.exports = __webpack_public_path__ + "assets/img/menu_bg_2.8eefe418.png";